<div class="dashboard">
  <!-- EXT-6104: the ecomStatus-driven title/button-column redesign (EXT-6043)
  is scoped to newSite() dealers only -- a legacy (non-newSite) dealer must
  keep seeing what's currently live on PROD regardless of ecomStatus.
  EXT-6571: the newSite version lives in the shared library, so Platform
  Portal's banner screens can preview it. -->
  @if (newSite()) {
    <jfw-wholesale-dealer-dashboard-hero
      [banner]="cmsBanner()"
      [ecomStatus]="ecomStatus()"
      (balanceClick)="openBalance()"
    />
  } @else {
    <h1>Dashboard</h1>
    <div class="dashboard-banner-row">
      <div class="dashboard-banner-image">
        <picture>
          <source
            [media]="xsBreakpoint"
            srcset="assets/images/logos/referral_dashboard_main_mobile.webp"
          />
          <img
            src="assets/images/logos/referral_dashboard_main_1000x265.webp"
            alt="dashboard banner image"
            class="dashboard-image"
          />
        </picture>
      </div>
    </div>
  }

  <!-- Legacy (non-newSite) dealers always saw these pods pre-EXT-6043,
  regardless of ecomStatus -- app-referral-pods' own canAccessModule checks
  already return true unconditionally for !newSite(), so reusing it here
  reproduces that exactly instead of duplicating the old inline markup. -->
  @if (!newSite() || ecomStatus() === "O") {
    <app-referral-pods></app-referral-pods>
  }

  <!-- all wholesale modules must exist within newSite() @if block -->
  <!-- individual checks against new permissions model via hasModuleAccess() also required -->
  @if (newSite()) {
    @if (displayWholesalePods()) {
      <div class="pods">
        <jfw-wholesale-data-pods
          [actnum]="currentDealerId() ?? null"
          tablestyle="border-spacing: 8px"
          [platform_order_base_url]="platformOrderBaseUrl"
          (newDashboardPodEvent)="onNewItemListEvent($event)"
          parent_application="dealerportal"
          [newSite]="newSite() ?? false"
          [environment]="componentEnvironment"
          [showOrdersLastWeek]="true"
        ></jfw-wholesale-data-pods>
      </div>

      <div class="pod-lists">
        @if (orderList.length > 0) {
          <jfw-wholesale-order-list-view
            eztux_base_url="https://ezdevbo-1.jimsfw.com"
            [order_search_api_server_url]="orderSearchApiServerUrl"
            [receivedOrderList]="orderList"
            parent_application="dealerportal"
            [newSite]="newSite() ?? false"
            [environment]="componentEnvironment"
            [defaultSortKey]="orderListDefaultSort"
            [compactBelow]="1160"
          >
          </jfw-wholesale-order-list-view>
        }

        @if (eventList.length > 0) {
          <jfw-wholesale-potential-events-list-view
            eztux_base_url="https://ezdevbo-1.jimsfw.com"
            [platform_event_api_server_url]="platformEventApiServerUrl"
            [receivedEventList]="eventList"
            parent_application="dealerportal"
            [newSite]="newSite() ?? false"
            [environment]="componentEnvironment"
          >
          </jfw-wholesale-potential-events-list-view>
        }
      </div>
    }
    @if (displayDeliveryInfo() || displayAnnouncements()) {
      <app-account-info-dashboard></app-account-info-dashboard>
    }
  }
</div>
